var map = {
	"./AI.svg": [
		53409,
		3409
	],
	"./Alarm Check Filled.svg": [
		45942,
		5942
	],
	"./Alarm Check.svg": [
		22510,
		2510
	],
	"./Alarm Plus Filled.svg": [
		52330,
		2330
	],
	"./Alarm Plus.svg": [
		3490,
		3490
	],
	"./Alarm X Filled.svg": [
		70690,
		690
	],
	"./Alarm X.svg": [
		29754,
		9754
	],
	"./Answer Filled.svg": [
		96983,
		6983
	],
	"./Answer.svg": [
		8233,
		8233
	],
	"./Arrow Circle Down Filled.svg": [
		72214,
		2214
	],
	"./Arrow Circle Down.svg": [
		56366,
		6366
	],
	"./Arrow Circle Left Filled.svg": [
		76723,
		6723
	],
	"./Arrow Circle Left.svg": [
		47301,
		7301
	],
	"./Arrow Circle Right Filled.svg": [
		6592,
		6592
	],
	"./Arrow Circle Right.svg": [
		58120,
		8120
	],
	"./Arrow Circle Up Filled.svg": [
		77043,
		7043
	],
	"./Arrow Circle Up.svg": [
		57093,
		7093
	],
	"./Arrow Down Filled.svg": [
		49794,
		9794
	],
	"./Arrow Down.svg": [
		14138,
		4138
	],
	"./Arrow Left Filled.svg": [
		58783,
		8783
	],
	"./Arrow Left.svg": [
		89585,
		9585
	],
	"./Arrow Right Filled.svg": [
		48372,
		8372
	],
	"./Arrow Right.svg": [
		59900,
		9900
	],
	"./Arrow Square Down Filled.svg": [
		93623,
		3623
	],
	"./Arrow Square Down.svg": [
		51433,
		1433
	],
	"./Arrow Square Left Filled.svg": [
		57178,
		7178
	],
	"./Arrow Square Left.svg": [
		45842,
		5842
	],
	"./Arrow Square Right Filled.svg": [
		86135,
		6135
	],
	"./Arrow Square Right.svg": [
		25801,
		5801
	],
	"./Arrow Square Up Filled.svg": [
		59470,
		9470
	],
	"./Arrow Square Up.svg": [
		44998,
		4998
	],
	"./Arrow Up Filled.svg": [
		43319,
		3319
	],
	"./Arrow Up.svg": [
		61385,
		1385
	],
	"./ArrowDownLarge.svg": [
		24847,
		4847
	],
	"./ArrowLeftLarge.svg": [
		73110,
		3110
	],
	"./ArrowRightLarge.svg": [
		21453,
		1453
	],
	"./ArrowUpLarge.svg": [
		90886,
		886
	],
	"./Back.svg": [
		11746,
		1746
	],
	"./Banner Filled.svg": [
		52951,
		2951
	],
	"./Bell Filled.svg": [
		20044,
		44
	],
	"./Bell Plus Filled.svg": [
		64900,
		4900
	],
	"./Bell Plus.svg": [
		7692,
		7692
	],
	"./Bell Ringing.svg": [
		88214,
		8214
	],
	"./Bell.svg": [
		49300,
		9300
	],
	"./Bookmark Check Filled.svg": [
		86881,
		6881
	],
	"./Bookmark Check.svg": [
		37611,
		7611
	],
	"./Bookmark Filled.svg": [
		86869,
		6869
	],
	"./Bookmark Plus Filled.svg": [
		21839,
		1839
	],
	"./Bookmark Plus.svg": [
		63713,
		3713
	],
	"./Bookmark X.svg": [
		82271,
		2271
	],
	"./Bookmark.svg": [
		82207,
		2207
	],
	"./BookmarkFilled.svg": [
		4227,
		4227
	],
	"./Box 01 Filled.svg": [
		33925,
		3925
	],
	"./Box 01.svg": [
		72655,
		2655
	],
	"./Box 02 Filled.svg": [
		12116,
		2116
	],
	"./Box 02.svg": [
		86684,
		6684
	],
	"./Building Filled.svg": [
		3889,
		3889
	],
	"./Calculator.svg": [
		40691,
		691
	],
	"./Calendar Check Filled.svg": [
		68359,
		8359
	],
	"./Calendar Check.svg": [
		74969,
		4969
	],
	"./Calendar Date Filled.svg": [
		15637,
		5637
	],
	"./Calendar Date.svg": [
		18559,
		8559
	],
	"./Calendar Day Filled.svg": [
		3377,
		3377
	],
	"./Calendar Day.svg": [
		11387,
		1387
	],
	"./Calendar Filled.svg": [
		41727,
		1727
	],
	"./Calendar Minus Filled.svg": [
		27695,
		7695
	],
	"./Calendar Minus.svg": [
		35937,
		5937
	],
	"./Calendar Plus Filled.svg": [
		62137,
		2137
	],
	"./Calendar Plus.svg": [
		98147,
		8147
	],
	"./Calendar Search Filled.svg": [
		91045,
		1045
	],
	"./Calendar Search.svg": [
		58415,
		8415
	],
	"./Calendar X Filled.svg": [
		815,
		815
	],
	"./Calendar X.svg": [
		21377,
		1377
	],
	"./Calendar.svg": [
		28273,
		8273
	],
	"./Call.svg": [
		86855,
		6855
	],
	"./Camera Plus Filled.svg": [
		19838,
		9838
	],
	"./Camera Plus.svg": [
		38838,
		8838
	],
	"./Camera.svg": [
		49182,
		9182
	],
	"./Caret Down Filled.svg": [
		68304,
		8304
	],
	"./Caret Down.svg": [
		28248,
		8248
	],
	"./Caret Left Filled.svg": [
		32749,
		2749
	],
	"./Caret Left.svg": [
		32791,
		2791
	],
	"./Caret Right Filled.svg": [
		51610,
		1610
	],
	"./Caret Right.svg": [
		22866,
		2866
	],
	"./Caret Up Filled.svg": [
		20321,
		321
	],
	"./Caret Up.svg": [
		69579,
		9579
	],
	"./CaretDown.svg": [
		91248,
		1248
	],
	"./CaretLeft.svg": [
		22719,
		2719
	],
	"./CaretRight.svg": [
		36410,
		6410
	],
	"./CaretUp.svg": [
		70243,
		243
	],
	"./Channeltalk.svg": [
		36298,
		6298
	],
	"./Chat Filled.svg": [
		37299,
		7299
	],
	"./Chat.svg": [
		7685,
		7685
	],
	"./Check Circle Broken Filled.svg": [
		4954,
		4954
	],
	"./Check Circle Broken.svg": [
		41042,
		1042
	],
	"./Check Circle Filled.svg": [
		17845,
		7845
	],
	"./Check Circle.svg": [
		90335,
		335
	],
	"./Check Filled.svg": [
		96743,
		6743
	],
	"./Check Square Broken Filled.svg": [
		29387,
		9387
	],
	"./Check Square Broken.svg": [
		85405,
		5405
	],
	"./Check Square Double Filled.svg": [
		71495,
		1495
	],
	"./Check Square Double.svg": [
		99449,
		9449
	],
	"./Check Square Filled.svg": [
		99862,
		9862
	],
	"./Check Square.svg": [
		49742,
		9742
	],
	"./Check Verified Filled.svg": [
		56937,
		6937
	],
	"./Check Verified.svg": [
		16179,
		6179
	],
	"./Check-Circle.svg": [
		758,
		758
	],
	"./Check.svg": [
		47577,
		7577
	],
	"./CheckBox.svg": [
		34252,
		4252
	],
	"./Chevron Down Double filled.svg": [
		75661,
		5661
	],
	"./Chevron Down Double.svg": [
		33367,
		3367
	],
	"./Chevron Down filled.svg": [
		14376,
		4376
	],
	"./Chevron Down.svg": [
		2160,
		2160
	],
	"./Chevron Left Double filled.svg": [
		75126,
		5126
	],
	"./Chevron Left Double.svg": [
		18286,
		8286
	],
	"./Chevron Left filled.svg": [
		97429,
		7429
	],
	"./Chevron Left.svg": [
		62911,
		2911
	],
	"./Chevron Right Double filled.svg": [
		99971,
		9971
	],
	"./Chevron Right Double.svg": [
		55093,
		5093
	],
	"./Chevron Right filled.svg": [
		52994,
		2994
	],
	"./Chevron Right.svg": [
		45498,
		5498
	],
	"./Chevron Up Double filled.svg": [
		40442,
		442
	],
	"./Chevron Up Double.svg": [
		12562,
		2562
	],
	"./Chevron Up Filled.svg": [
		28921,
		8921
	],
	"./Chevron Up.svg": [
		25891,
		5891
	],
	"./Clip.svg": [
		40181,
		181
	],
	"./Clipboard Check Filled.svg": [
		56737,
		6737
	],
	"./Clipboard Check.svg": [
		27979,
		7979
	],
	"./Clipboard Plus Filled.svg": [
		83375,
		3375
	],
	"./Clipboard Plus.svg": [
		45153,
		5153
	],
	"./Clipboard Search Filled.svg": [
		7019,
		7019
	],
	"./Clipboard Search.svg": [
		11549,
		1549
	],
	"./Clipboard X.svg": [
		54527,
		4527
	],
	"./Clock Check Filled.svg": [
		39741,
		9741
	],
	"./Clock Check.svg": [
		48583,
		8583
	],
	"./Clock Filled.svg": [
		96265,
		6265
	],
	"./Clock Plus Filled.svg": [
		95163,
		5163
	],
	"./Clock Plus.svg": [
		88077,
		8077
	],
	"./Clock X Filled.svg": [
		92073,
		2073
	],
	"./Clock X.svg": [
		61491,
		1491
	],
	"./Clock.svg": [
		2643,
		2643
	],
	"./Comment Circle Answer Filled.svg": [
		52716,
		2716
	],
	"./Comment Circle Answer.svg": [
		66580,
		6580
	],
	"./Comment Circle Check Filled.svg": [
		68742,
		8742
	],
	"./Comment Circle Check.svg": [
		26462,
		6462
	],
	"./Comment Circle Dots Filled.svg": [
		73810,
		3810
	],
	"./Comment Circle Dots.svg": [
		30346,
		346
	],
	"./Comment Circle Exclamation Filled.svg": [
		14967,
		4967
	],
	"./Comment Circle Exclamation.svg": [
		34345,
		4345
	],
	"./Comment Circle Filled.svg": [
		20570,
		570
	],
	"./Comment Circle Information Filled.svg": [
		75372,
		5372
	],
	"./Comment Circle Information.svg": [
		80724,
		724
	],
	"./Comment Circle Minus Filled.svg": [
		39074,
		9074
	],
	"./Comment Circle Minus.svg": [
		99674,
		9674
	],
	"./Comment Circle Plus Filled.svg": [
		14938,
		4938
	],
	"./Comment Circle Plus.svg": [
		55698,
		5698
	],
	"./Comment Circle Question Filled.svg": [
		96830,
		6830
	],
	"./Comment Circle Question.svg": [
		51766,
		1766
	],
	"./Comment Circle X Filled.svg": [
		41586,
		1586
	],
	"./Comment Circle X.svg": [
		83498,
		3498
	],
	"./Comment Circle.svg": [
		94642,
		4642
	],
	"./Comment Filled.svg": [
		17694,
		7694
	],
	"./Comment.svg": [
		27062,
		7062
	],
	"./Content Filled.svg": [
		52242,
		2242
	],
	"./Content.svg": [
		61866,
		1866
	],
	"./Dashboard Filled.svg": [
		99675,
		9675
	],
	"./Dashboard.svg": [
		45261,
		5261
	],
	"./Desktop Filled.svg": [
		70683,
		683
	],
	"./Desktop.svg": [
		90829,
		829
	],
	"./Document Attachment Filled.svg": [
		20893,
		893
	],
	"./Document Check Filled.svg": [
		98816,
		8816
	],
	"./Document Check.svg": [
		74536,
		4536
	],
	"./Document Download Filled.svg": [
		73144,
		3144
	],
	"./Document Download.svg": [
		7008,
		7008
	],
	"./Document Filled.svg": [
		98824,
		8824
	],
	"./Document Minus Filled.svg": [
		32112,
		2112
	],
	"./Document Minus.svg": [
		92472,
		2472
	],
	"./Document Plus Filled.svg": [
		52168,
		2168
	],
	"./Document Plus.svg": [
		37136,
		7136
	],
	"./Document Question Filled.svg": [
		99172,
		9172
	],
	"./Document Question.svg": [
		80972,
		972
	],
	"./Document Search Filled.svg": [
		16644,
		6644
	],
	"./Document Search.svg": [
		27884,
		7884
	],
	"./Document Upload Filled.svg": [
		6673,
		6673
	],
	"./Document Upload.svg": [
		83451,
		3451
	],
	"./Document X Filled.svg": [
		83600,
		1219
	],
	"./Document X.svg": [
		18328,
		8328
	],
	"./Document.svg": [
		82800,
		2800
	],
	"./Dots Grid Filled.svg": [
		44319,
		4319
	],
	"./Dots Grid.svg": [
		4497,
		4497
	],
	"./Dots Horizontal Filled.svg": [
		51179,
		1179
	],
	"./Dots Horizontal.svg": [
		63197,
		3197
	],
	"./Dots Vertical Filled.svg": [
		96593,
		6593
	],
	"./Dots Vertical.svg": [
		4475,
		4475
	],
	"./Download.svg": [
		72335,
		2335
	],
	"./Edit 01 Filled.svg": [
		92596,
		2596
	],
	"./Edit 01.svg": [
		41212,
		1212
	],
	"./Edit 02 Filled.svg": [
		76357,
		6357
	],
	"./Edit 02.svg": [
		3887,
		3887
	],
	"./Envelope.svg": [
		283,
		283
	],
	"./EnvelopeOutLined.svg": [
		61949,
		1949
	],
	"./Exclamation Mark Circle Filled.svg": [
		33097,
		3097
	],
	"./Exclamation Mark Circle.svg": [
		1555,
		1555
	],
	"./Exclamation Mark Filled.svg": [
		98131,
		8131
	],
	"./Exclamation Mark Polygon Filled Filled.svg": [
		11415,
		1415
	],
	"./Exclamation Mark Polygon.svg": [
		86931,
		6931
	],
	"./Exclamation Mark Square Filled.svg": [
		7770,
		7770
	],
	"./Exclamation Mark Square.svg": [
		88434,
		8434
	],
	"./Exclamation Mark.svg": [
		14437,
		4437
	],
	"./Eye Closed Filled.svg": [
		27970,
		7970
	],
	"./Eye Closed.svg": [
		54970,
		4970
	],
	"./Eye Filled.svg": [
		53578,
		3578
	],
	"./Eye.svg": [
		71650,
		1650
	],
	"./File Check Filled.svg": [
		73995,
		3995
	],
	"./File Check.svg": [
		66909,
		6909
	],
	"./File Plus Filled.svg": [
		1933,
		1933
	],
	"./File Plus.svg": [
		25303,
		5303
	],
	"./File Search Filled.svg": [
		61313,
		1313
	],
	"./File Search.svg": [
		66443,
		6443
	],
	"./File X Filled.svg": [
		34395,
		4395
	],
	"./File X.svg": [
		98042,
		8042
	],
	"./File.svg": [
		93181,
		3181
	],
	"./FileArrowDown.svg": [
		61080,
		1080
	],
	"./FileList.svg": [
		4325,
		4325
	],
	"./Filter.svg": [
		96953,
		6953
	],
	"./Folder Check Filled.svg": [
		10317,
		317
	],
	"./Folder Check.svg": [
		62615,
		2615
	],
	"./Folder Plus Filled.svg": [
		89515,
		9515
	],
	"./Folder Plus.svg": [
		4477,
		4477
	],
	"./Folder Search Filled.svg": [
		23711,
		3711
	],
	"./Folder Search.svg": [
		35281,
		5281
	],
	"./Folder X.svg": [
		44451,
		4451
	],
	"./Full Screen Exit Filled.svg": [
		56068,
		6068
	],
	"./Full Screen Exit.svg": [
		16172,
		6172
	],
	"./Full Screen Filled.svg": [
		46380,
		6380
	],
	"./Full Screen.svg": [
		81492,
		1492
	],
	"./Heart Filled.svg": [
		28859,
		8859
	],
	"./Heart.svg": [
		85133,
		5133
	],
	"./Home Filled.svg": [
		2718,
		2718
	],
	"./Home.svg": [
		95798,
		5798
	],
	"./ID Card Filled.svg": [
		55358,
		5358
	],
	"./ID Card.svg": [
		38134,
		8134
	],
	"./Image Check Filled.svg": [
		45854,
		5854
	],
	"./Image Check.svg": [
		29174,
		9174
	],
	"./Image Filled.svg": [
		39282,
		9282
	],
	"./Image Minus Filled.svg": [
		89418,
		9418
	],
	"./Image Minus.svg": [
		8834,
		8834
	],
	"./Image Plus Filled.svg": [
		74802,
		4802
	],
	"./Image Plus.svg": [
		28458,
		8458
	],
	"./Image X Filled.svg": [
		36954,
		6954
	],
	"./Image X.svg": [
		46418,
		6418
	],
	"./Image.svg": [
		73130,
		3130
	],
	"./Inbox 01 Filled.svg": [
		17742,
		7742
	],
	"./Inbox 01.svg": [
		12326,
		2326
	],
	"./Inbox 02 Filled.svg": [
		71443,
		1443
	],
	"./Inbox 02.svg": [
		34757,
		4757
	],
	"./Information Circle Filled.svg": [
		23295,
		3295
	],
	"./Information Circle.svg": [
		8593,
		8593
	],
	"./Information Square Filled.svg": [
		58700,
		8700
	],
	"./Information Square Polygon Filled.svg": [
		14438,
		4438
	],
	"./Information Square Polygon.svg": [
		25246,
		5246
	],
	"./Information Square.svg": [
		71508,
		1508
	],
	"./Job Filled.svg": [
		7192,
		7192
	],
	"./Job.svg": [
		60672,
		672
	],
	"./Kakao.svg": [
		2710,
		2710
	],
	"./Link.svg": [
		71927,
		1927
	],
	"./List Bullet Filled.svg": [
		29475,
		9475
	],
	"./List Bullet.svg": [
		10037,
		37
	],
	"./List Check Filled.svg": [
		96881,
		9262
	],
	"./List Check.svg": [
		21979,
		1979
	],
	"./List CheckBox.svg": [
		89290,
		9290
	],
	"./List Filled.svg": [
		28805,
		8805
	],
	"./List Number Filled.svg": [
		93042,
		3042
	],
	"./List Number.svg": [
		170,
		170
	],
	"./List.svg": [
		10415,
		415
	],
	"./MagnifyingGlass Filled.svg": [
		48152,
		8152
	],
	"./MagnifyingGlass.svg": [
		57216,
		7216
	],
	"./MailBox Filled.svg": [
		35899,
		5899
	],
	"./MailBox.svg": [
		23405,
		3405
	],
	"./Map Pin Check Filled.svg": [
		81222,
		1222
	],
	"./Map Pin Check.svg": [
		93470,
		3470
	],
	"./MapPin.svg": [
		91540,
		1540
	],
	"./Media.svg": [
		50677,
		677
	],
	"./Minus.svg": [
		36993,
		6993
	],
	"./Mobile Filled.svg": [
		97319,
		7319
	],
	"./Mobile.svg": [
		92569,
		2569
	],
	"./More.svg": [
		4668,
		4668
	],
	"./Navigation.svg": [
		66757,
		6757
	],
	"./New Circle Filled.svg": [
		94643,
		4643
	],
	"./Pages Filled.svg": [
		34055,
		4055
	],
	"./Pages.svg": [
		77017,
		7017
	],
	"./Paperplane Filled.svg": [
		79069,
		9069
	],
	"./Paperplane.svg": [
		6407,
		6407
	],
	"./Pencil.svg": [
		84512,
		4512
	],
	"./Phone Plus Filled.svg": [
		52169,
		2169
	],
	"./Phone Plus.svg": [
		99987,
		9987
	],
	"./Phone X Filled.svg": [
		71519,
		1519
	],
	"./Phone X.svg": [
		27505,
		7505
	],
	"./Phone.svg": [
		54721,
		4721
	],
	"./Pin 01 Filled.svg": [
		25751,
		5751
	],
	"./Pin 01.svg": [
		35177,
		5177
	],
	"./Pin 02 Filled.svg": [
		45250,
		5250
	],
	"./Pin 02.svg": [
		9594,
		9594
	],
	"./Play Circle Filled.svg": [
		65665,
		5665
	],
	"./Play Circle.svg": [
		43019,
		3019
	],
	"./Play Filled.svg": [
		20827,
		827
	],
	"./Play.svg": [
		42605,
		2605
	],
	"./Plus Circle Filled.svg": [
		72639,
		2639
	],
	"./Plus Circle.svg": [
		92241,
		2241
	],
	"./Plus Filled.svg": [
		39321,
		9321
	],
	"./Plus Square Filled.svg": [
		43468,
		3468
	],
	"./Plus Square.svg": [
		2324,
		2324
	],
	"./Plus.svg": [
		47331,
		7331
	],
	"./PolygonDown.svg": [
		48375,
		8375
	],
	"./PolygonLeft.svg": [
		6664,
		6664
	],
	"./PolygonRight.svg": [
		92343,
		2343
	],
	"./PolygonUp.svg": [
		79048,
		9048
	],
	"./Print Filled.svg": [
		86268,
		6268
	],
	"./Print.svg": [
		5284,
		5284
	],
	"./Question Filled.svg": [
		18833,
		8833
	],
	"./Question Mark Filled.svg": [
		57098,
		7098
	],
	"./Question Mark.svg": [
		89570,
		9570
	],
	"./Question.svg": [
		3515,
		3515
	],
	"./Radio .svg": [
		70896,
		896
	],
	"./Radio Filled.svg": [
		43784,
		3784
	],
	"./Radio.svg": [
		89008,
		9008
	],
	"./RadioChecked.svg": [
		71747,
		1747
	],
	"./Recruit Filled.svg": [
		18501,
		8501
	],
	"./Recruit.svg": [
		50031,
		31
	],
	"./Refresh.svg": [
		33976,
		3976
	],
	"./Reset.svg": [
		41668,
		1668
	],
	"./Search Filled.svg": [
		60069,
		2450
	],
	"./Search Minus Filled.svg": [
		27253,
		7253
	],
	"./Search Minus.svg": [
		17471,
		7471
	],
	"./Search Plus Filled.svg": [
		9279,
		9279
	],
	"./Search Plus.svg": [
		20305,
		305
	],
	"./Search Reflection Filled.svg": [
		23646,
		3646
	],
	"./Search Reflection.svg": [
		9302,
		9302
	],
	"./Search.svg": [
		40079,
		79
	],
	"./Secondhands.svg": [
		28839,
		8839
	],
	"./Series.svg": [
		19028,
		9028
	],
	"./Setting 01 Filled.svg": [
		68694,
		8694
	],
	"./Setting 01.svg": [
		41294,
		1294
	],
	"./Setting 02 Filled.svg": [
		28155,
		8155
	],
	"./Setting 02.svg": [
		89645,
		9645
	],
	"./SettingFilled.svg": [
		40069,
		69
	],
	"./Share 03 Filled.svg": [
		93773,
		3773
	],
	"./Share 03.svg": [
		38551,
		8551
	],
	"./Share.svg": [
		62508,
		2508
	],
	"./Share01.svg": [
		3053,
		3053
	],
	"./Spinner.svg": [
		88646,
		8646
	],
	"./Star.svg": [
		1687,
		1687
	],
	"./Swap Vertical.svg": [
		244,
		244
	],
	"./Text Background Color Filled.svg": [
		87365,
		7365
	],
	"./Text Background Color.svg": [
		47663,
		7663
	],
	"./Text Color Filled.svg": [
		74289,
		4289
	],
	"./Text Color.svg": [
		73243,
		3243
	],
	"./Text Filled.svg": [
		65742,
		5742
	],
	"./Text.svg": [
		75526,
		5526
	],
	"./Thumbs Down Filled.svg": [
		72488,
		2488
	],
	"./Thumbs Down.svg": [
		63600,
		3600
	],
	"./Thumbs Up Filled.svg": [
		1561,
		1561
	],
	"./Thumbs Up.svg": [
		995,
		995
	],
	"./Timer.svg": [
		2930,
		2930
	],
	"./TimerSmall.svg": [
		50511,
		511
	],
	"./Trash Filled.svg": [
		4889,
		4889
	],
	"./Trash.svg": [
		30435,
		435
	],
	"./Upload.svg": [
		93392,
		3392
	],
	"./User Check Filled.svg": [
		36614,
		6614
	],
	"./User Check.svg": [
		83582,
		3582
	],
	"./User Circle Filled.svg": [
		37502,
		7502
	],
	"./User Circle.svg": [
		71478,
		1478
	],
	"./User Edit Filled.svg": [
		45938,
		5938
	],
	"./User Edit.svg": [
		42026,
		2026
	],
	"./User Filled.svg": [
		41466,
		1466
	],
	"./User Plus Filled.svg": [
		28570,
		8570
	],
	"./User Plus.svg": [
		98770,
		8770
	],
	"./User.svg": [
		98834,
		6453
	],
	"./Vip Filled.svg": [
		81868,
		1868
	],
	"./Vip.svg": [
		92852,
		2852
	],
	"./Volume Max Filled.svg": [
		55293,
		5293
	],
	"./Volume Max.svg": [
		76967,
		6967
	],
	"./Volume Plus Filled.svg": [
		8905,
		8905
	],
	"./Volume Plus.svg": [
		3347,
		3347
	],
	"./Volume X Filled.svg": [
		40940,
		940
	],
	"./Volume X.svg": [
		95313,
		5313
	],
	"./Window.svg": [
		34259,
		4259
	],
	"./Won.svg": [
		15729,
		5729
	],
	"./X.svg": [
		80097,
		97
	],
	"./XFilled.svg": [
		82785,
		2785
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 28838;
module.exports = webpackAsyncContext;